import { ConfigProvider } from 'antd';
import React, { useCallback, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { getLocaleAntd } from './translations';

export const AntdLocalProviderWrapper = ({ children }: React.PropsWithChildren<{}>) => {
  const [locale, setLocale] = useState(getLocaleAntd());

  const { i18n } = useTranslation();

  const changeLocale = useCallback((value) => {
    setLocale(getLocaleAntd(value));
  }, []);

  useEffect(() => {
    i18n.on('languageChanged', (value) => {
      changeLocale(value);
    });

    return () => {
      i18n.off('languageChange', changeLocale);
    };
  }, [i18n, changeLocale]);

  return <ConfigProvider locale={locale}>{children}</ConfigProvider>;
};
